import { format } from "date-fns";
import { CalendarRange } from "lucide-react";

export default function AttendanceRangePicker({
    rangeType,
    setRangeType,
    selectedDate,
    setSelectedDate,
    selectedYear,
    setSelectedYear,
    searchText,
    setSearchText,
    employeeStatusFilter, setEmployeeStatusFilter,
    loggedInUser
}) {
    const formatMonth = (date) => date.toLocaleString("en-US", { month: "long" });
    const formatDate = (date) => format(date, "MMM dd, yyyy");

    let startDate = new Date();
    let endDate = new Date();

    switch (rangeType) {
        case "yesterday":
            startDate.setDate(startDate.getDate() - 1);
            endDate = new Date(startDate);
            break;
        case "7 days":
            startDate.setDate(startDate.getDate() - 6);
            break;
        case "30 days":
            startDate.setDate(startDate.getDate() - 29);
            break;
        case "monthly":
            startDate = new Date(selectedYear, selectedDate.getMonth(), 1);
            endDate = new Date(selectedYear, selectedDate.getMonth() + 1, 0);
            break;
        case "yearly":
            startDate = new Date(selectedYear, 0, 1);
            endDate = new Date(selectedYear, 11, 31);
            break;
    }

    const canFilterStatus = ["Admin", "HR", "Management"].includes(loggedInUser?.department);

    return (
        <div className="flex  flex-wrap items-start sm:items-center gap-2 bg-white border border-gray-200 rounded-md sm:rounded-xl px-3 py-2 shadow-sm w-full">
            {/* Date Display */}
            <div className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer hover:text-gray-900 w-full sm:w-auto">
                <CalendarRange className="w-4 h-4 text-gray-500" />
                <span className="text-[12px] sm:text-sm font-medium whitespace-nowrap">
                    {rangeType === "monthly"
                        ? `${formatMonth(startDate)} ${selectedYear}`
                        : rangeType === "yearly"
                            ? selectedYear
                            : `${formatDate(startDate)} – ${formatDate(endDate)}`}
                </span>
            </div>

            {/* Controls */}
            <div
                className={`flex ${rangeType === "monthly" ? "flex-col zs:flex-row" : "flex-row"
                    } items-start sm:items-center gap-2 w-full sm:w-auto`}
            >
                {/* Month Selector */}
                {rangeType === "monthly" && (
                    <select
                        value={selectedDate.getMonth()}
                        onChange={(e) => {
                            const newDate = new Date(selectedDate);
                            newDate.setMonth(Number(e.target.value));
                            setSelectedDate(newDate);
                        }}
                        className="px-2 py-1 text-sm max-[540px]:text-xs bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        {Array.from({ length: 12 }, (_, i) => (
                            <option key={i} value={i}>
                                {new Date(0, i).toLocaleString("en-US", { month: "long" })}
                            </option>
                        ))}
                    </select>
                )}

                {/* Year Selector */}
                {(rangeType === "monthly" || rangeType === "yearly") && (
                    <select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                        className="px-2 py-1 text-sm max-[540px]:text-xs bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        {Array.from({ length: 2050 - 2024 + 1 }, (_, i) => 2024 + i).map(
                            (year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            )
                        )}
                    </select>
                )}

                {/* Range Type Selector */}
                <select
                    value={rangeType}
                    onChange={(e) => setRangeType(e.target.value)}
                    className="px-2 py-1 text-sm max-[540px]:text-xs bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="7 days">Last 7 Days</option>
                    <option value="30 days">Last 30 Days</option>
                    <option value="monthly">Monthly</option>
                    {/* <option value="yearly">Yearly</option> */}
                </select>

                {/* Search Input */}
                <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search by User Id or Name"
                    className="px-3 py-1 text-[12px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-[220px]"
                />

                {canFilterStatus && (
                    <select
                        value={employeeStatusFilter}
                        onChange={(e) => setEmployeeStatusFilter(e.target.value)}
                        className="px-2 py-1 text-sm max-[540px]:text-xs bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="Active">Active</option>
                        <option value="Trainee">Trainee</option>
                        <option value="Terminated">Terminated</option>
                        <option value="All">All</option>
                    </select>
                )}
            </div>
        </div>
    );
}